/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageorders2Inputs */

const en_ticketpageorders2 = /** @type {(inputs: Ticketpageorders2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const de_ticketpageorders2 = /** @type {(inputs: Ticketpageorders2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Ticketpageorders2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageorders2 = /** @type {((inputs?: Ticketpageorders2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageorders2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageorders2(inputs)
	return de_ticketpageorders2(inputs)
});
export { ticketpageorders2 as "ticketPageOrders" }